// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
=============== 
Variables
===============
*/

:root {
    --clr-lega-purple: #6b5b95;
    --clr-lega-dark-purple: #50394c;
    /* dark shades of primary color*/
    --clr-primary-1: hsl(205, 86%, 17%);
    --clr-primary-2: hsl(205, 77%, 27%);
    --clr-primary-3: hsl(205, 72%, 37%);
    --clr-primary-4: hsl(205, 63%, 48%);
    /* primary/main color */
    --clr-primary-5: hsl(205, 78%, 60%);
    /* lighter shades of primary color */
    --clr-primary-6: hsl(205, 89%, 70%);
    --clr-primary-7: hsl(205, 90%, 76%);
    --clr-primary-8: hsl(205, 86%, 81%);
    --clr-primary-9: hsl(205, 90%, 88%);
    --clr-primary-10: hsl(205, 100%, 96%);
    /* darkest grey - used for headings */
    --clr-grey-1: hsl(209, 61%, 16%);
    --clr-grey-2: hsl(211, 39%, 23%);
    --clr-grey-3: hsl(209, 34%, 30%);
    --clr-grey-4: hsl(209, 28%, 39%);
    /* grey used for paragraphs */
    --clr-grey-5: hsl(210, 22%, 49%);
    --clr-grey-6: hsl(209, 23%, 60%);
    --clr-grey-7: hsl(211, 27%, 70%);
    --clr-grey-8: hsl(210, 31%, 80%);
    --clr-grey-9: hsl(212, 33%, 89%);
    --clr-grey-10: hsl(210, 36%, 96%);
    --clr-white: #fff;
    --clr-red-dark: hsl(360, 67%, 44%);
    --clr-red-light: hsl(360, 71%, 66%);
    --clr-green-dark: hsl(125, 67%, 44%);
    --clr-green-light: hsl(125, 71%, 66%);
    --clr-black: #222;
    --transition: all 0.3s linear;
    --spacing: 0.1rem;
    --radius: 0.25rem;
    --light-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    --dark-shadow: 0 5px 15px rgba(0, 0, 0, 0.4);
    --max-width: 1170px;
    --fixed-width: 450px;
    --clr-orange-1: hsl(12, 83%, 98%);
    --clr-orange-2: hsl(14, 91%, 95%);
    --clr-orange-3: hsl(12, 89%, 89%);
    --clr-orange-4: hsl(13, 87%, 82%);
    --clr-orange-5: hsl(13, 88%, 68%);
    --clr-orange-6: hsl(13, 88%, 55%);
    --clr-orange-7: hsl(13, 74%, 49%);
    --clr-orange-8: hsl(13, 74%, 33%);
    --clr-orange-9: hsl(13, 73%, 25%);
    --clr-orange-10: hsl(13, 73%, 16%);
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    font-family: "游ゴシック Medium", YuGothic, "游ゴシック体", "メイリオ", "Hiragino Kaku Gothic ProN", "ヒラギノ角ゴ ProN W3", "HiraKakuProN-W3", "Yu Gothic Medium", sans-serif;
    /* font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; */
    background: #f1f5f8;
    color: #222;
}

h1 {
    font-size: 1.4rem;
    font-weight: bold;
}

h4 {
    font-size: 1rem;
    font-weight: bold;
}


/*
=============== 
Global Styles
===============
*/

*,
::after,
::before {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    background: var(--clr-grey-10);
    color: var(--clr-grey-1);
    line-height: 1.5;
    font-size: 0.875rem;
}

ul {
    list-style-type: none;
}

a {
    text-decoration: none;
}

h1,
h2,
h3,
h4 {
    letter-spacing: var(--spacing);
    text-transform: capitalize;
    line-height: 1.25;
    margin-bottom: 0.75rem;
}

h1 {
    font-size: 1.4rem;
}

h2 {
    font-size: 1.3rem;
}

h3 {
    font-size: 1rem;
}

h4 {
    font-size: 0.875rem;
}

p {
    margin-bottom: 0rem;
    color: var(--clr-grey-5);
}

@media screen and (min-width: 800px) {
    h1 {
        font-size: 1.5rem;
    }
    h2 {
        font-size: 1.3rem;
    }
    h3 {
        font-size: 1.75rem;
    }
    h4 {
        font-size: 1rem;
    }
    body {
        font-size: 0.875rem;
    }
    h1,
    h2,
    h3,
    h4 {
        line-height: 1;
    }
}


/*  global classes */


/* section */

.section {
    width: 90vw;
    margin: 0 auto;
    max-width: var(--max-width);
}

@media screen and (min-width: 992px) {
    .section {
        width: 95vw;
    }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;;CAIC;;AAED;IACI,0BAA0B;IAC1B,+BAA+B;IAC/B,gCAAgC;IAChC,mCAAmC;IACnC,mCAAmC;IACnC,mCAAmC;IACnC,mCAAmC;IACnC,uBAAuB;IACvB,mCAAmC;IACnC,oCAAoC;IACpC,mCAAmC;IACnC,mCAAmC;IACnC,mCAAmC;IACnC,mCAAmC;IACnC,qCAAqC;IACrC,qCAAqC;IACrC,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,6BAA6B;IAC7B,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,iCAAiC;IACjC,iBAAiB;IACjB,kCAAkC;IAClC,mCAAmC;IACnC,oCAAoC;IACpC,qCAAqC;IACrC,iBAAiB;IACjB,6BAA6B;IAC7B,iBAAiB;IACjB,iBAAiB;IACjB,6CAA6C;IAC7C,4CAA4C;IAC5C,mBAAmB;IACnB,oBAAoB;IACpB,iCAAiC;IACjC,iCAAiC;IACjC,iCAAiC;IACjC,iCAAiC;IACjC,iCAAiC;IACjC,iCAAiC;IACjC,iCAAiC;IACjC,iCAAiC;IACjC,iCAAiC;IACjC,kCAAkC;AACtC;;AAEA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,yJAAyJ;IACzJ,8IAA8I;IAC9I,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;;AAGA;;;;CAIC;;AAED;;;IAGI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,wIAAwI;IACxI,8BAA8B;IAC9B,wBAAwB;IACxB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;;;IAII,8BAA8B;IAC9B,0BAA0B;IAC1B,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI;QACI,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,eAAe;IACnB;IACA;QACI,mBAAmB;IACvB;IACA;;;;QAII,cAAc;IAClB;AACJ;;;AAGA,oBAAoB;;;AAGpB,YAAY;;AAEZ;IACI,WAAW;IACX,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI;QACI,WAAW;IACf;AACJ","sourcesContent":["/*\r\n=============== \r\nVariables\r\n===============\r\n*/\r\n\r\n:root {\r\n    --clr-lega-purple: #6b5b95;\r\n    --clr-lega-dark-purple: #50394c;\r\n    /* dark shades of primary color*/\r\n    --clr-primary-1: hsl(205, 86%, 17%);\r\n    --clr-primary-2: hsl(205, 77%, 27%);\r\n    --clr-primary-3: hsl(205, 72%, 37%);\r\n    --clr-primary-4: hsl(205, 63%, 48%);\r\n    /* primary/main color */\r\n    --clr-primary-5: hsl(205, 78%, 60%);\r\n    /* lighter shades of primary color */\r\n    --clr-primary-6: hsl(205, 89%, 70%);\r\n    --clr-primary-7: hsl(205, 90%, 76%);\r\n    --clr-primary-8: hsl(205, 86%, 81%);\r\n    --clr-primary-9: hsl(205, 90%, 88%);\r\n    --clr-primary-10: hsl(205, 100%, 96%);\r\n    /* darkest grey - used for headings */\r\n    --clr-grey-1: hsl(209, 61%, 16%);\r\n    --clr-grey-2: hsl(211, 39%, 23%);\r\n    --clr-grey-3: hsl(209, 34%, 30%);\r\n    --clr-grey-4: hsl(209, 28%, 39%);\r\n    /* grey used for paragraphs */\r\n    --clr-grey-5: hsl(210, 22%, 49%);\r\n    --clr-grey-6: hsl(209, 23%, 60%);\r\n    --clr-grey-7: hsl(211, 27%, 70%);\r\n    --clr-grey-8: hsl(210, 31%, 80%);\r\n    --clr-grey-9: hsl(212, 33%, 89%);\r\n    --clr-grey-10: hsl(210, 36%, 96%);\r\n    --clr-white: #fff;\r\n    --clr-red-dark: hsl(360, 67%, 44%);\r\n    --clr-red-light: hsl(360, 71%, 66%);\r\n    --clr-green-dark: hsl(125, 67%, 44%);\r\n    --clr-green-light: hsl(125, 71%, 66%);\r\n    --clr-black: #222;\r\n    --transition: all 0.3s linear;\r\n    --spacing: 0.1rem;\r\n    --radius: 0.25rem;\r\n    --light-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\r\n    --dark-shadow: 0 5px 15px rgba(0, 0, 0, 0.4);\r\n    --max-width: 1170px;\r\n    --fixed-width: 450px;\r\n    --clr-orange-1: hsl(12, 83%, 98%);\r\n    --clr-orange-2: hsl(14, 91%, 95%);\r\n    --clr-orange-3: hsl(12, 89%, 89%);\r\n    --clr-orange-4: hsl(13, 87%, 82%);\r\n    --clr-orange-5: hsl(13, 88%, 68%);\r\n    --clr-orange-6: hsl(13, 88%, 55%);\r\n    --clr-orange-7: hsl(13, 74%, 49%);\r\n    --clr-orange-8: hsl(13, 74%, 33%);\r\n    --clr-orange-9: hsl(13, 73%, 25%);\r\n    --clr-orange-10: hsl(13, 73%, 16%);\r\n}\r\n\r\n* {\r\n    margin: 0;\r\n    padding: 0;\r\n    box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n    font-family: \"游ゴシック Medium\", YuGothic, \"游ゴシック体\", \"メイリオ\", \"Hiragino Kaku Gothic ProN\", \"ヒラギノ角ゴ ProN W3\", \"HiraKakuProN-W3\", \"Yu Gothic Medium\", sans-serif;\r\n    /* font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; */\r\n    background: #f1f5f8;\r\n    color: #222;\r\n}\r\n\r\nh1 {\r\n    font-size: 1.4rem;\r\n    font-weight: bold;\r\n}\r\n\r\nh4 {\r\n    font-size: 1rem;\r\n    font-weight: bold;\r\n}\r\n\r\n\r\n/*\r\n=============== \r\nGlobal Styles\r\n===============\r\n*/\r\n\r\n*,\r\n::after,\r\n::before {\r\n    margin: 0;\r\n    padding: 0;\r\n    box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\r\n    background: var(--clr-grey-10);\r\n    color: var(--clr-grey-1);\r\n    line-height: 1.5;\r\n    font-size: 0.875rem;\r\n}\r\n\r\nul {\r\n    list-style-type: none;\r\n}\r\n\r\na {\r\n    text-decoration: none;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4 {\r\n    letter-spacing: var(--spacing);\r\n    text-transform: capitalize;\r\n    line-height: 1.25;\r\n    margin-bottom: 0.75rem;\r\n}\r\n\r\nh1 {\r\n    font-size: 1.4rem;\r\n}\r\n\r\nh2 {\r\n    font-size: 1.3rem;\r\n}\r\n\r\nh3 {\r\n    font-size: 1rem;\r\n}\r\n\r\nh4 {\r\n    font-size: 0.875rem;\r\n}\r\n\r\np {\r\n    margin-bottom: 0rem;\r\n    color: var(--clr-grey-5);\r\n}\r\n\r\n@media screen and (min-width: 800px) {\r\n    h1 {\r\n        font-size: 1.5rem;\r\n    }\r\n    h2 {\r\n        font-size: 1.3rem;\r\n    }\r\n    h3 {\r\n        font-size: 1.75rem;\r\n    }\r\n    h4 {\r\n        font-size: 1rem;\r\n    }\r\n    body {\r\n        font-size: 0.875rem;\r\n    }\r\n    h1,\r\n    h2,\r\n    h3,\r\n    h4 {\r\n        line-height: 1;\r\n    }\r\n}\r\n\r\n\r\n/*  global classes */\r\n\r\n\r\n/* section */\r\n\r\n.section {\r\n    width: 90vw;\r\n    margin: 0 auto;\r\n    max-width: var(--max-width);\r\n}\r\n\r\n@media screen and (min-width: 992px) {\r\n    .section {\r\n        width: 95vw;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
